import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Grid, Col, Row, Form
} from 'react-bootstrap'
import Card from '../../components/Card/Card'
import { constants } from '../../redux/lessons/actions'
import { commonConstants } from '../../redux/common/actions'
import Button from '../../components/CustomButton/CustomButton.jsx'
import NotificationSystem from 'react-notification-system'
import { style as notificationStyling } from '../../variables/Variables.jsx'
import { Link } from 'react-router-dom'
import SweetAlert from 'react-bootstrap-sweetalert'
import { getFormattedUser } from '../../services/auth'
import moment from 'moment'
import { scoreLessonResponses } from '../../utils/lessonScore'

const { FETCH_LESSON_LIST, DELETE_LESSON } = constants
const { REQUEST } = commonConstants

const LessonList = ({ history }) => {
  const { list, error = {}, success = {} } = useSelector(state => state.lessons)
  const dispatch = useDispatch()
  const notificationSystem = useRef()
  const [alert, setAlert] = useState(null)
  const [_notificationSystem, setNotificationSystem] = useState({})

  // retrieve admin privilege/user if applicable
  const [hasAdmin, setHasAdmin] = useState(false)
  useEffect(() => {
    setNotificationSystem(notificationSystem)
    const getAuth = async () => {
      const user = await getFormattedUser()
      dispatch({ type: FETCH_LESSON_LIST + REQUEST, source: FETCH_LESSON_LIST, payload: { call_taker_id: user.id } })
      const hasAdmin = user && user.roles &&
        (user.roles.includes('SuperAdmin') || user.roles.includes('HrAdmin'))
      setHasAdmin(hasAdmin)
    }
    getAuth().then()
  }, [])
  // handle ajax side effects
  useEffect(() => {
    const notificationSystem = _notificationSystem.current
    if (notificationSystem && success.message) { notificationSystem.addNotification({ message: success.message, level: 'info', position: 'tc' }) }
    if (notificationSystem && error.message) { notificationSystem.addNotification({ message: error.message, level: 'error', position: 'tc' }) }
    return () => { }
  }, [success.message, error.message])

  // handle onClick row navigation
  const [historyNavigation, setHistoryNavigation] = useState({ enabled: false, id: null, completed: false })
  useEffect(() => {
    if (historyNavigation.enabled) {
      if(historyNavigation.completed){
        history.push(`/admin/module/${historyNavigation.id}/summary`)
      } else {
        history.push(`/admin/module/${historyNavigation.id}?readOnly=true`)
      }
    }
    return () => { }
  }, [historyNavigation.enabled])

  // handle scroll to top for notifications
  useEffect(() => {
    // THIS IS SCREWY - Desktop works fine, Mobile scrolls to top quickly then back to original position - 2x fixed this
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    return () => { }
  }, [success.message, error.message])

  const formattedList = useMemo(() => {
    return list
    // .map(l => {
    //   return {
    //     ...l,
    //     dateVerified: moment(l.dateVerified).format('MMMM, Do YYYY')
    //   }
    // })
  }, [list])

  const renderDeleteConfirm = (lessonTitle, id, dispatch) => {
    return setAlert((
      <SweetAlert
        showCancel
        style={{ display: 'block', marginTop: '-100px' }}
        title="Confirm Deletion"
        onConfirm={() => dispatch({ type: DELETE_LESSON + REQUEST, payload: { id } }) && setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="danger"
      >
        {`Are you sure you want to delete this module "${lessonTitle}"?`}
      </SweetAlert>
    ))
  }

  // const filterMethod = (filter, row, column) => {
  //   const id = filter.pivotId || filter.id
  //   return (row[id] !== null && row[id] !== undefined) ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase()) : true
  // }

  const renderLessonItems = () => {
    return formattedList.map((prop, key) => {
      const { questionsLeft: questionsLeftCount, allCorrect: allCorrectAnswers } =
        scoreLessonResponses(prop.questions, prop.responses)

      const moduleNumber = prop.id

      return (
        <Card
          key={prop.id}
          content={
            <Row>
              <Form>
                <Grid fluid>
                  <Row>
                    <div>
                      <Col xs={12} sm={8}>
                        <h3><b>Module #{moduleNumber}: </b>{prop.title}</h3>
                        <h6><b>Date: </b>{moment(prop.updatedAt).format('MMMM DD, YYYY')}</h6>
                        <div style={{marginTop: 10}}>{prop.description}</div>
                      </Col>
                    </div>
                    <Col xs={12} sm={4} style={{textAlign: 'right'}}>
                      <Button
                        onClick={() => setHistoryNavigation({ enabled: true, id: prop.id, completed: prop.completed })}
                        bsStyle="primary"
                        bsSize="lg"
                      >
                        {prop.completed &&
                        'Module Summary'
                        }
                        {!prop.completed &&
                        'View Module'
                        }
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6}>
                      {questionsLeftCount <= 0 && prop.completed && !allCorrectAnswers &&
                        <h4 className='text-danger'><b>Module Incomplete</b></h4>
                      }
                      {questionsLeftCount <= 0 && prop.completed && allCorrectAnswers &&
                        <h4 className='text-success'><b>Module Complete</b></h4>
                      }
                      {questionsLeftCount <= 0 && !prop.completed &&
                        <h4 className='text-warning'><b>Module In Progress</b></h4>
                      }
                      {questionsLeftCount > 0 &&
                        <h4 className='text-warning'><b>{questionsLeftCount} Question{questionsLeftCount === 1 ? '' : 's'} left to answer</b></h4>
                      }
                    </Col>
                    {hasAdmin &&
                      <Col style={{ marginLeft: 20, textAlign: 'right' }}>
                        <div className="actions-center">
                            <Link to={`/admin/create-module/${prop.id}`}>
                            <Button
                              bsStyle="warning"
                              simple icon>
                              <i className="pe-7s-pen action-icon" style={{ color: 'blue' }} />
                            </Button>{" "}
                          </Link>
                          <Button
                            onClick={() => renderDeleteConfirm(prop.title, prop.id, dispatch)}
                            bsStyle="danger"
                            simple icon>
                            <i className="pe-7s-trash action-icon" />
                          </Button>
                        </div>
                      </Col>
                    }
                  </Row>
                </Grid>
              </Form>

            </Row>
          }
        />
      )
    })
  }

  return (
    <div className='main-content'>
      <NotificationSystem ref={notificationSystem} style={notificationStyling} />
      {alert}
      <Card
        content={
          <div>
            {(hasAdmin) &&
              <>
                <div style={{ marginBottom: 20 }}>
                  <Link to={`/admin/create-module`}>
                    <Button round fill>
                      Create New Module
                    </Button>
                  </Link>
                </div>
              </>
            }
            {formattedList.length > 0 && renderLessonItems()}
            {formattedList.length <= 0 &&
              <div style={{ marginLeft: 14 }}><b>No Current Modules</b></div>
            }
          </div>
        }
      />
    </div>
  )
}

export default LessonList